/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateExerciseWeightDto } from './create-exercise-weight-dto';
import { EnExerciseType } from './en-exercise-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateSessionExerciseDto
 */
export interface UpdateSessionExerciseDto {

    /**
     * Rest between sets
     *
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    rest?: number;

    /**
     * Number of exercise repetitions
     *
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    reps?: number;

    /**
     * Number of set (each set include repetitions)
     *
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    sets?: number;

    /**
     * @type {EnExerciseType}
     * @memberof UpdateSessionExerciseDto
     */
    type?: EnExerciseType;

    /**
     * Progressive number of exercise into the session
     *
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    sequence?: number;

    /**
     * Playback speed of the linked exercise
     *
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    speed?: number;

    /**
     * @type {string}
     * @memberof UpdateSessionExerciseDto
     */
    note?: string | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateSessionExerciseDto
     */
    exercise?: JoinEntityDto;

    /**
     * Session-level weight overrides per body part (tier 3)
     *
     * @type {Array<CreateExerciseWeightDto>}
     * @memberof UpdateSessionExerciseDto
     */
    weights?: Array<CreateExerciseWeightDto>;

    /**
     * @type {number}
     * @memberof UpdateSessionExerciseDto
     */
    id: number;
}
